import * as React from 'react'

type Props = {
    href: string
    children: React.ReactNode
    id?: string
    className?: string
    label?: string
    role?: string
    noFollow?: boolean
}

const ExternalLink = ({id, className, href, label, role, children, noFollow = true}: Props) => {
    return (
        <a
            id={id}
            className={className}
            target="_blank"
            rel={`noopener noreferrer ${noFollow ? 'nofollow' : ''}`}
            href={href}
            aria-label={label}
            role={role}
        >
            {children}
        </a>
    )
}

export default ExternalLink
